<app-moveable-panel>
  <div class="flex flex-col">
    <app-movable-panel-title>
      <div class="grow flex items-center justify-between">
        <span>{{ 'multi-site-dashboard.chargers-overview.title' | translate }}</span>
        <div class="flex items-center">
          <ng-content></ng-content>
        </div>
      </div>
    </app-movable-panel-title>

    @if (isLoading()) {
      <app-chargers-overview-movable-panel-loading-skeleton />
    } @else if (vm()) {
      @let viewModel = vm()!;
      <div class="flex px-2">
        <div class="grow flex flex-col px-6 py-4 gap-6 rounded-radius-container bg-background-container-primary">
          <div class="flex items-center gap-2 text-lg font-semibold">
            <svg-icon key="charging-station-20"></svg-icon>
            <div>{{ 'dashboard.infrastructure-overview.chargers' | translate }}</div>
          </div>
          <div class="grid grid-cols-[repeat(auto-fit,125px)] gap-4">
            <app-infrastructure-overview-section [title]="ChargerStateStoreModelEnum.Operational | appTranslateChargerState">
              <div class="flex items-center">
                <app-status
                  [status]="StatusViewModelEnum.Success"
                  [value]="viewModel.chargers[ChargerStateStoreModelEnum.Operational].count"
                ></app-status>
              </div>
            </app-infrastructure-overview-section>

            <app-infrastructure-overview-section [title]="ChargerStateStoreModelEnum.Offline | appTranslateChargerState">
              <div class="flex items-center">
                <app-status
                  [status]="StatusViewModelEnum.Disabled"
                  [value]="viewModel.chargers[ChargerStateStoreModelEnum.Offline].count"
                  [acrossSiteCount]="viewModel.chargers[ChargerStateStoreModelEnum.Offline].siteCount"
                ></app-status>
              </div>
            </app-infrastructure-overview-section>

            <app-infrastructure-overview-section [title]="ChargerStateStoreModelEnum.Faulted | appTranslateChargerState">
              <div class="flex items-center">
                <app-status
                  [status]="StatusViewModelEnum.Error"
                  icon="faulted-16"
                  [value]="viewModel.chargers[ChargerStateStoreModelEnum.Faulted].count"
                  [acrossSiteCount]="viewModel.chargers[ChargerStateStoreModelEnum.Faulted].siteCount"
                ></app-status>
              </div>
            </app-infrastructure-overview-section>

            <app-infrastructure-overview-section [title]="ChargerStateStoreModelEnum.Maintenance | appTranslateChargerState">
              <div class="flex items-center">
                <app-status
                  [status]="StatusViewModelEnum.Warning"
                  [value]="viewModel.chargers[ChargerStateStoreModelEnum.Maintenance].count"
                  [acrossSiteCount]="viewModel.chargers[ChargerStateStoreModelEnum.Maintenance].siteCount"
                ></app-status>
              </div>
            </app-infrastructure-overview-section>
          </div>
        </div>
      </div>
    }
    <div class="flex items-center justify-end p-4">
      <a [routerLink]="[RouteSegment.Root, RouteSegment.Sites]">
        <app-panel-link [label]="'multi-site-dashboard.view-sites' | translate"></app-panel-link>
      </a>
    </div>
  </div>
</app-moveable-panel>
